import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import {
  GetServiceSetData,
  GetShareInfoSetByShareInfoID,
  GetSubscriptionSetData,
} from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import { IAccountInfo } from "./TempAccount";
import Blank from "../../../../DefaultStyles/Blank";
import { Input } from "../../../../Input/Input";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../../Modal/DefaultModalLayout";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import SubscriptionSection from "./TempAccountModal/SubscriptionSection";
import TempAccountDeleteModal from "./TempAccountModal/TempAccountDeleteModal";
import RentPartySection from "./TempAccountModal/RentPartySection";
import { Textarea } from "../../../../Input/Textarea";
import { checkIsPwAutoChangeSubs } from "../../../../../ApiTS/ApiPwAutoChangeTS";
import PwAutoChangeBtn from "./TempAccountModal/PwAutoChangeBtn";

interface TempAccountModalProps extends DefaultModalCommonProps {
  accountInfo?: IAccountInfo;
}

export const tempAccountModalState = atom({
  key: "tempAccountModalState",
  default: {
    servsubsid: 0,
    loginType: "",
    email: "",
    pw: "",
    pin: "",
  },
});

export default function TempAccountModal({
  closeEvent,
  confirmEvent,
  accountInfo,
  type,
}: TempAccountModalProps) {
  console.log("ssss");

  const [modalType, setModalType] = useRecoilState(defaultModalType);
  const [deleteModal, setDeleteModal] = useState(false);

  const tempAccountModalStateValue = useRecoilValue(tempAccountModalState);

  // console.log(tempAccountModalStateValue);

  const [loginType, setLoginType] = useState(
    accountInfo ? accountInfo?.type ?? "" : ""
  );
  const [email, setEmail] = useState(accountInfo ? accountInfo?.email : "");
  const [pw, setPw] = useState(accountInfo ? accountInfo?.pw : "");
  const [pin, setPin] = useState(accountInfo ? accountInfo?.pin : "");
  const [pay, setPay] = useState(
    accountInfo?.pay !== "" ? accountInfo?.pay : "-"
  );
  const [duedate, setDuedate] = useState("");
  const [comment, setComment] = useState(
    accountInfo ? accountInfo?.comment : ""
  );
  const [rentPartyList, setRentPartyList] = useState(
    accountInfo ? accountInfo?.partyid : []
  );

  const [addTempAccount, setAddTempAccount] = useState(false);
  const [editTempAccount, setEditTempAccount] = useState(false);

  const subsData = GetSubscriptionSetData(
    tempAccountModalStateValue?.servsubsid ?? 0
  )[0];
  const shareInfoData = GetShareInfoSetByShareInfoID(subsData?.SHARINFO_ID)[0];

  const filteredRentPartyList = rentPartyList?.filter(
    (d) => d !== "__undefined",
    rentPartyList
  );

  // 임시 계정 추가하기
  const { response: addTempAccountResponse, error: addTempAccountError } =
    useApi({
      method: "post",
      url: addTempAccount ? `temp-account` : undefined,
      data: {
        servid:
          GetSubscriptionSetData(tempAccountModalStateValue?.servsubsid ?? 0)[0]
            ?.SVC_ID ?? 0,
        servsubsid: tempAccountModalStateValue?.servsubsid ?? 0,
        loginType: loginType === "-" ? "" : loginType,
        email,
        pw,
        pin,
        comment,
        pay,
      },
    });

  // 임시 계정 수정하기
  const { response: editTempAccountResponse, error: editTempAccountError } =
    useApi({
      method: "post",
      url: editTempAccount ? `temp-account/${accountInfo?.id}` : undefined,
      data: {
        pw,
        pin,
        partyid: filteredRentPartyList,
        duedate:
          filteredRentPartyList?.length > 0
            ? filteredRentPartyList[filteredRentPartyList?.length - 1]?.split(
                "_"
              )[2]
            : "",
        comment,
        pay: pay === "-" ? "" : pay,
      },
    });

  useEffect(() => {
    console.log("✅ rentPartyList", rentPartyList);
  }, [rentPartyList]);

  useEffect(() => {
    if (addTempAccountResponse?.status === 200) {
      closeEvent();

      toast.success("임시 계정이 추가되었습니다.");

      if (confirmEvent) {
        confirmEvent();
      }
    }
  }, [addTempAccountResponse]);

  useEffect(() => {
    if (editTempAccountResponse?.status === 200) {
      closeEvent();

      toast.success("임시 계정이 수정되었습니다.");

      if (confirmEvent) {
        confirmEvent();
      }
    }
  }, [editTempAccountResponse]);

  useEffect(() => {
    if (addTempAccountError || editTempAccountError) {
      console.log(addTempAccountError, editTempAccountError);
      toast.error(addTempAccountError?.data ?? editTempAccountError?.data);
    }
  }, [addTempAccountError, editTempAccountError]);

  useEffect(() => {
    setModalType(type);
  }, [type]);

  useEffect(() => {
    const subsId = tempAccountModalStateValue?.servsubsid;
    if (subsId !== 0) {
      setLoginType(
        subsId === 4000 || subsId === 4001
          ? "TVING ID"
          : subsId === 3000
          ? "WAVVE"
          : subsId === 2000
          ? "email"
          : subsId === 16000
          ? "email"
          : "-"
      );
    }
  }, [tempAccountModalStateValue?.servsubsid]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        if (modalType === "input") {
          setAddTempAccount(true);
        } else if (modalType === "edit") {
          setEditTempAccount(true);
        } else {
          closeEvent();
        }
      }}
      confirmDisabled={
        modalType === "input"
          ? tempAccountModalStateValue.servsubsid === 0 ||
            email === "" ||
            pw === ""
          : modalType === "edit"
          ? accountInfo?.email === email &&
            accountInfo?.pw === pw &&
            accountInfo?.type === loginType &&
            accountInfo?.duedate === duedate &&
            accountInfo?.comment === comment &&
            accountInfo?.pay === pay &&
            JSON.stringify(accountInfo?.partyid) ===
              JSON.stringify(filteredRentPartyList)
          : false
      }
      deleteBtnShow={modalType === "view"}
      deleteBtnClickEvent={() => setDeleteModal(true)}
      modalTitle={
        modalType === "view"
          ? "임시 계정 보기"
          : modalType === "edit"
          ? "임시 계정 수정"
          : "임시 계정 추가"
      }
      leftBottomTime={modalType === "view" ? accountInfo?.update : undefined}
      leftBottomName={
        modalType === "view" ? accountInfo?.admin?.split("_")[1] : undefined
      }
      checkScrollHeight={true}
      changingEditEvent={() => {
        if (rentPartyList?.length === 0) {
          setRentPartyList([""]);
        }
      }}
    >
      <>
        {/* 서비스 */}
        {modalType !== "input" && (
          <ModalRow>
            <ModalLabel>서비스</ModalLabel>

            <ModalRowContentContainer>
              <HasInitValueBox style={{ width: "100%" }}>
                {GetServiceSetData(subsData?.SVC_ID)[0]?.SVC_NMKR_TEMP}_
                {accountInfo?.id}
              </HasInitValueBox>
            </ModalRowContentContainer>
          </ModalRow>
        )}

        {/* Subscription */}
        <SubscriptionSection accountInfo={accountInfo} type={type} />

        {/* 로그인 수단 */}
        <ModalRow>
          <ModalLabel>로그인 수단</ModalLabel>

          <ModalRowContentContainer>
            <Input
              type="text"
              value={loginType}
              onChange={(e) => setLoginType(e.target.value)}
              readOnly={modalType !== "input"}
              disabled={
                tempAccountModalStateValue?.servsubsid < 6000 ||
                tempAccountModalStateValue?.servsubsid === 15001 ||
                tempAccountModalStateValue?.servsubsid === 16000 ||
                tempAccountModalStateValue?.servsubsid === 17000 ||
                tempAccountModalStateValue?.servsubsid === 17001
              }
            />
          </ModalRowContentContainer>
        </ModalRow>

        {/* 계정 */}
        <ModalRow>
          <ModalLabel>계정</ModalLabel>

          <ModalRowContentContainer>
            <Input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              readOnly={modalType === "edit" || modalType === "view"}
            />
          </ModalRowContentContainer>
        </ModalRow>

        {/* 비밀번호 */}
        <ModalRow>
          <ModalLabel>비밀번호</ModalLabel>

          <ModalRowContentContainer>
            <Input
              type="text"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              readOnly={modalType === "view"}
            />

            {modalType === "edit" &&
              checkIsPwAutoChangeSubs(subsData?.SUBS_ID) && (
                <PwAutoChangeBtn
                  subsId={subsData?.SUBS_ID}
                  id={email}
                  pw={pw}
                  confirmEvent={(newPw) => {
                    setPw(newPw);
                    setEditTempAccount(true);
                  }}
                />
              )}
          </ModalRowContentContainer>
        </ModalRow>

        {/* 성인 비밀번호 */}
        {(modalType === "edit" || accountInfo?.pin !== "") &&
          (shareInfoData?.INQ_ADLTPW ?? 0) === 1 && (
            <ModalRow>
              <ModalLabel>성인 비밀번호</ModalLabel>

              <ModalRowContentContainer>
                <Input
                  type="text"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                  readOnly={modalType === "view"}
                />
              </ModalRowContentContainer>
            </ModalRow>
          )}

        {/* 결제 수단 */}
        <ModalRow>
          <ModalLabel>결제 수단</ModalLabel>

          <ModalRowContentContainer>
            <Input
              type="text"
              value={pay}
              onChange={(e) => setPay(e.target.value)}
              readOnly={modalType === "view"}
            />
          </ModalRowContentContainer>
        </ModalRow>

        {/* 대여 정보 */}
        {modalType !== "input" && (
          <RentPartySection
            rentPartyList={rentPartyList}
            setRentPartyList={setRentPartyList}
            modalType={modalType}
          />
        )}

        {/* 비고 */}
        <>
          <ModalLabel>비고</ModalLabel>

          <Textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            readOnly={modalType === "view"}
            style={{ marginTop: 16, marginBottom: 20 }}
          />
        </>

        <Blank blankHeight={40} />

        {deleteModal ? (
          <TempAccountDeleteModal
            cancelEvent={() => setDeleteModal(false)}
            tempAccountId={accountInfo?.id ?? 0}
            closeEvent={() => {
              closeEvent();

              if (confirmEvent) {
                confirmEvent();
              }
            }}
          />
        ) : (
          <></>
        )}
      </>
    </DefaultModalLayout>
  );
}
